import { render, staticRenderFns } from "./EventMicrositeNew2.vue?vue&type=template&id=fcc44ae0&scoped=true"
import script from "./EventMicrositeNew2.vue?vue&type=script&lang=js"
export * from "./EventMicrositeNew2.vue?vue&type=script&lang=js"
import style0 from "./EventMicrositeNew2.vue?vue&type=style&index=0&id=fcc44ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc44ae0",
  null
  
)

export default component.exports